import { Box, Typography, Button, Stack, TextField, CircularProgress, IconButton, FormLabel, useTheme } from '@mui/material';
import { IconEye, IconEyeClosed } from '@tabler/icons-react';
import { useState } from 'react';
import { dispatch } from 'src/store/Store';
import { setToastMessage } from 'src/store/my_pages/app';
import axiosIn from 'src/middlewares/axiosInterceptor';
import { getApiUrl, apiConfig } from 'src/config/apiConfig';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import PasswordStrengthBar from 'src/my_pages/PasswordStrengthBar';

const ResetPassForm = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || ''; 

  const [fd, _setfd] = useState<any>({});
  const [isLoading, setIsLoading] = useState(false);
  const [showPass, setShowPass] = useState({
    current: false,
    new: false,
    confirm: false,
  });

  const theme = useTheme();
  const navigate = useNavigate();

  const setFd = (key: string, value: any) => {
    _setfd((prev) => ({ ...prev, [key]: value }));
  };

  const handleChangePassword = async () => {
    // dispatch(setToastMessage({ msg: 'Server is not available for this operation currently', color: 'warning' }));
    // return;
    setIsLoading(true);
    try {
      if (fd.newPass !== fd.confirmNewPass) {
        dispatch(setToastMessage({ msg: 'Passwords do not match', color: 'error' }));
        return;
      }

      const data = {
        // current_password: fd.currentPass,
        // token: encodeURIComponent(token),
        token: token,
        newPassword: fd.newPass,
      };

      const url = getApiUrl(apiConfig.auth_reset_password);
      const res = await axiosIn.post(url, data);

      if (res.status === 200) {
        navigate('/auth/login');
        dispatch(setToastMessage({ msg: 'Password set successfully', color: 'success' }));
        _setfd({});
      }
    } catch (error: any) {
      const errMsg = error.response?.data?.[0]?.message || Object.values(error.response?.data?.errors)?.toString() || 'Error';
      dispatch(setToastMessage({ msg: errMsg, color: 'error' }));
    } finally {
      setIsLoading(false);
    }
  };

  const renderPasswordField = (label: string, key: 'currentPass' | 'newPass' | 'confirmNewPass') => (
    <Box mt={2}>
      <FormLabel htmlFor={key}>{label}</FormLabel>
      <TextField
        id={key}
        type={showPass[key] ? 'text' : 'password'}
        variant="outlined"
        fullWidth
        value={fd[key] || ''}
        onChange={(e: any) => setFd(key, e.target.value)}
        InputProps={{
          endAdornment: (
            <IconButton aria-label={'show/hide'} onClick={() => setShowPass((prev) => ({ ...prev, [key]: !prev[key] }))}>
              {showPass[key] ? <IconEye /> : <IconEyeClosed />}
            </IconButton>
          ),
        }}
      />
    </Box>
  );

  return (
    <Box color={theme.palette.text.primary}>
      <Stack>
        {/* {renderPasswordField('Current Password', 'currentPass')} */}
        {renderPasswordField('New Password', 'newPass')}
        <PasswordStrengthBar password={fd.newPass || ''} />
        <ul style={{ marginTop: '2px', marginBottom: '10px', paddingLeft: '18px' }}>
          <li style={{}}>
            <Typography color="textSecondary" textAlign="start" variant="body2" sx={{ mb: 2, fontSize: 'smaller', padding: 0, margin: 0, lineHeight: 1.2 }}>
              Minimum 8 characters
            </Typography>
          </li>
          <li style={{}}>
            <Typography color="textSecondary" textAlign="start" variant="body2" sx={{ mb: 2, fontSize: 'smaller', padding: 0, margin: 0, lineHeight: 1.2 }}>
              Uppercase & lowercase letters
            </Typography>
          </li>
          <li style={{}}>
            <Typography color="textSecondary" textAlign="start" variant="body2" sx={{ mb: 2, fontSize: 'smaller', padding: 0, margin: 0, lineHeight: 1.2 }}>
              Number or special character
            </Typography>
          </li>
        </ul>
        {renderPasswordField('Confirm New Password', 'confirmNewPass')}
      </Stack>

      <Box mt={'48px'}>
        <Button disabled={fd.newPass !== fd.confirmNewPass} color="primary" variant="contained" size="large" fullWidth onClick={handleChangePassword}>
          Change Password {isLoading && <CircularProgress color="primary" size={20} sx={{ mt: 0, mx: 2 }} />}
        </Button>
      </Box>
      <Box mt={2}>
        <Typography
          component={Link}
          to="/auth/forgot-password"
          fontWeight="500"
          sx={{
            textDecoration: 'none',
            color: 'primary.main',
          }}
        >
          Remember your password?
        </Typography>
      </Box>
    </Box>
  );
};

export default ResetPassForm;
